import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export type FilesType = {
  folders?: string[] | null;
  files?:
    | {
        name: string;
        size: number;
        last_modified: string;
      }[]
    | null;
};

export class Files {
  static async retrieve(prefix: string): Promise<FilesType> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/files`);
    url.searchParams.set("prefix", prefix);
    const response = await request(url, { method: "GET" }, true);
    const data = await response.json();
    return data as FilesType;
  }

  static async makeSignerURL(key: string): Promise<string> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/files`);
    url.searchParams.set("key", key);
    const response = await request(url, { method: "PUT" }, true, `Generated signed URL for ${key}`);
    const data = await response.json();
    return data.url;
  }
}
